import React from 'react'
import ImageFlipcard from '../../../components/landingPage/Flipcards/ImageFlipcard';
import Section from '../../landingPage/Section';
import { DDDCIPP, DDDClinics, DDDLabs, DDDCoE } from '../../../images';


const flipcards = [
  {
    id: 1,
    image: DDDClinics,
    title: "Specialized clinics",
    content: "May conduct the Scan & Go consultation using an Intra-Oral Scanner (IOS), refer you to the nearest CoE for the complete XiViX Process, and support you throughout your journey."
  },
  {
    id: 2,
    image: DDDCoE,
    title: "Centers of Excellence",
    content: "One-stop clinic for the complete XiViX Process, fully equipped with 3D scanners (IOS, Face, & CBCT) and integrating specialized practitioners for surgeries &/or pre-prosthetic treatments."
  },
  {
    id: 3,
    image: DDDCIPP,
    title: "Center of Intelligence, Planning & Production",
    content: "The centralised technologies, platform & AI at CIPP help analyse scans, diagnose & propose treatment plans, design smiles, select quality material, manufacture prostheses and ensure precise protocols."
  },
  {
    id: 4,
    image: DDDLabs,
    title: "Laboratories",
    content: "Our ceramists and lab technicians give the final customized cosmetic touch to your restorations."
  }
];

function OurNetwork() {
  return (
    <Section title="Our network" subtitle="A group of complementary competencies in all concerned disciplines at your service." className="mt-10 lg:mt-20 mb-8" id="DigitalDentalDesign">
      <div className="grid grid-cols-1 mt-8 sm:grid-cols-2 lg:gap-8 lg:max-w-max xl:grid-cols-4 place-items-center mx-auto">
        {flipcards.map(flipcard => {
          return (
          <ImageFlipcard flipcard={flipcard} id={flipcard.id} key={flipcard.id}/>
        )
        })}
      </div>
    </Section>
    
  )
  
}

export default OurNetwork
